export default __webpack_public_path__ + "static/media/jpjh.69c730ed.svg";